module.exports = __webpack_public_path__ + "img/520dc28.png";